const dsSlider = require("./ds-slider");

module.exports = dsSlider;
